import flowRuleApi from '@/api/config/flowRuleApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { getApiErrorMessage } from '@/helpers'

function useSearchFlowSrcId(interfaceId: number) {
  return useQuery({
    queryKey: [queryKeys.newRule],
    queryFn: async () => {
      const { data } = await flowRuleApi.getSrcId(interfaceId)

      if (!data) return null

      return data
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useSearchFlowSrcId
